module.exports = __webpack_public_path__ + "static/img/pc_help5.cb97cc3e.png";